import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Collapsible, { CollapseEventListener } from '@philips-emr/tws-core/lib/component/types/collapsible';
import Pageable, { PageEventListener } from '@philips-emr/tws-core/lib/component/types/pageable';
import Renderable, { RenderEventListener } from '@philips-emr/tws-core/lib/component/types/renderable';
import Sortable, { SortEventListener } from '@philips-emr/tws-core/lib/component/types/sortable';

class DataTableAPI extends ComponentAPI implements Sortable, Renderable, Pageable, Clickable, Collapsible {
  /** @event */
  @AwesomeEvent
  onSort = new SortEventListener();

  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onNextPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onPrevPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onCollapse = new CollapseEventListener();

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  getKeyField(): string {
    return this.state.keyField;
  }

  setKeyField(keyField: string): void {
    this.setState({ keyField });
  }

  isMultiSelect(): boolean {
    return this.state.multiselect;
  }

  setMultiSelect(multiselect: boolean): void {
    this.setState({ multiselect });
  }

  getSelectedRows(): object[] {
    return this.state.selectedRows;
  }

  setSelectedRows(selectedRows: object[]): void {
    if (Array.isArray(selectedRows)) {
      this.setState({ selectedRows });
    }
  }

  getHiddenColumns(): string[] {
    return this.state.hiddenColumns;
  }

  hideColumns(column: string|string[]): void {
    const empty: string[] = [];
    const columns = empty.concat(column);
    const hiddenColumns = [...this.state.hiddenColumns, ...columns];

    this.setState({ hiddenColumns });
  }

  showColumns(column: string|string[]): void {
    const empty: string[] = [];
    const columns = empty.concat(column);
    const hiddenColumns = this.getHiddenColumns();

    this.setState({
      hiddenColumns: hiddenColumns.filter(
        (column) => !columns.includes(column)
      ),
    });
  }

  isCollapsed(): boolean {
    return this.state.collapsed;
  }

  setCollapsed(value: boolean): void {
    this.setState({ collapsed: value });
  }
}

export default DataTableAPI;
